<div class="toolbar">
    <app-container-standard title="Sales Report">
        <div class="form-row">
            <div class="form-group col-md-4">
                <mat-form-field class="example-full-width">
                    <mat-select placeholder="Select company" #select multiple
                        (selectionChange)="onComanySelectChange(null)" [(ngModel)]="selectValue" multiple>
                        <mat-checkbox [(ngModel)]="allCompaniesSelected" (change)="selectAllCompanies()">Select
                            All</mat-checkbox>
                        <mat-option *ngFor="let option of companies$ | async" (click)="setCompany(option)"
                            [value]="option.name">
                            {{ option.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-group col-md-4">
                <mat-form-field class="example-full-width">
                    <mat-select placeholder="Select system" [formControl]="systemControl" multiple>
                        <mat-option *ngFor="let option of filteredSystems$ | async" (click)="setSystem(option)"
                            [value]="option.systemName">
                            {{ option.systemName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-group col-md-3" *ngIf="categories$| async; let i">
                <mat-form-field class="example-full-width" *ngIf="i.length > 0">
                    <mat-select placeholder="Select category" [formControl]="categoryControl" multiple>
                        <mat-option *ngFor="let option of categories$ | async" (click)="setCategory(option)"
                            [value]="option.name">
                            {{ option.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="form-group col-md-4">
                <mat-form-field>
                    <mat-select placeholder="Select time period" [(value)]="timeSelected"
                        (selectionChange)="setTimePeriodeEvent($event)">
                        <mat-option value="TODAY" selected>Today</mat-option>
                        <mat-option value="YESTERDAY">Yesterday</mat-option>
                        <mat-option value="24H">Last 24 hours</mat-option>
                        <mat-option value="THIS_MONTH">This month</mat-option>
                        <mat-option value="LAST_MONTH">Last month</mat-option>
                        <mat-option value="CUSTOM">Customized</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

        </div>
        <ng-container *ngIf="timeSelected == 'CUSTOM'">
            <mat-form-field>
                <mat-label>Custom Date Range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate placeholder="Start date" (dateChange)="setCustomRange($event, 'start')">
                    <input matEndDate placeholder="End date" (dateChange)="setCustomRange($event, 'end')">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </ng-container>


        <div class="form-row">
            <div class="form-group col-md-4">
                <div class="form-check">
                    <input class="form-check-input" (click)="vatCheck('withoutvat')" type="radio" name="vat"
                        id="flexRadioDefault1" checked>
                    <label class="form-check-label" for="flexRadioDefault1">
                        Without VAT
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" (click)="vatCheck(15)" type="radio" name="vat"
                        id="flexRadioDefault1">
                    <label class="form-check-label" for="flexRadioDefault1">
                        With 15% VAT
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" (click)="vatCheck(25)" type="radio" name="vat"
                        id="flexRadioDefault1">
                    <label class="form-check-label" for="flexRadioDefault1">
                        With 25% VAT
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" (click)="vatCheck(0)" type="radio" name="vat" id="flexRadioDefault2"
                        checked>
                    <label class="form-check-label" for="flexRadioDefault2">
                        Both
                    </label>
                </div>
            </div>

            <div class="form-group col-md-4">
                <div class="form-check">
                    <input class="form-check-input" (click)="viewCheck('GRAPH')" type="radio" name="view"
                        id="flexRadioDefault2" checked>
                    <label class="form-check-label" for="flexRadioDefault2">
                        Graphview
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" (click)="viewCheck('LIST')" type="radio" name="view"
                        id="flexRadioDefault1">
                    <label class="form-check-label" for="flexRadioDefault1">
                        Listview
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" (click)="viewCheck('CATGRAPH')" type="radio" name="view"
                        id="flexRadioDefault2">
                    <label class="form-check-label" for="flexRadioDefault2">
                        CategoryView
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" (click)="viewCheck('PRODUCTVIEW')" type="radio" name="view"
                        id="flexRadioDefault2">
                    <label class="form-check-label" for="flexRadioDefault2">
                        ProductView
                    </label>
                </div>
            </div>
            <div class="form-group col-md-4">
                <div class="form-check">
                    <input class="form-check-input" (click)="creditCheck('withCredit')" type="radio"
                        name="creditIncluded" id="flexRadioDefault1">
                    <label class="form-check-label" for="flexRadioDefault1">
                        Credit sale
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" (click)="creditCheck('withOutCredit')" type="radio"
                        name="creditIncluded" id="flexRadioDefault2">
                    <label class="form-check-label" for="flexRadioDefault2">
                        Without Credit sale
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" (click)="creditCheck('clear')" type="radio" name="creditIncluded"
                        id="flexRadioDefault2" checked>
                    <label class="form-check-label" for="flexRadioDefault2">
                        All
                    </label>
                </div>
            </div>
        </div>



        <div class="example-button-row">

            <button (click)="onSubmit()" class="theme-primary white-text " mat-flat-button>Create</button>

            <button *ngIf="dataSource.data.length > 0" (click)="exportToExcel()" class="theme-primary white-text "
                mat-flat-button>Export</button>

        </div>


    </app-container-standard>
</div>

<div *ngIf="showPieChart">
    <app-container-standard title="Revenue">
        <div class="row">
            <div class="col-6">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-sm-2 col-form-label">Total revenue</label>
                    <div class="col-sm-4">
                        <input type="text" disabled class="form-control" [value]="totalSale">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-sm-2 col-form-label">Number of sales</label>
                    <div class="col-sm-4">
                        <input type="text" disabled class="form-control" [value]="totalSaleQuanity">
                    </div>
                </div>

            </div>
            <div class="col-6">
                <app-peichart [pieChartData]="pieChartData" [peiLabels]="peiLabels"></app-peichart>
                <!-- <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [labels]="chartOptions.labels"
                    [responsive]="chartOptions.responsive"></apx-chart> -->
            </div>
        </div>

    </app-container-standard>
</div>

<div class="row">
    <div *ngIf="isViewCheckActive == 'CATGRAPH' && salesReport.length >0 && svinnReport.length >0 " class="col-12">
        <app-container-standard title="Categories Count">

            <app-sale-svinn [salesReport]="salesReport" [svinnReport]="svinnReport"></app-sale-svinn>

            <!-- <app-stackedBarChart [data]="salesDataGraph" [salesDataGraph]="salesDataGraph"
                [categories]="systemsNameForChart"></app-stackedBarChart> -->
        </app-container-standard>

    </div>
    <!-- <div *ngIf="isViewCheckActive == 'CATGRAPH' && salesReport.length >0 && svinnReport.length >0 " class="col-12">
        <app-container-standard title="Categories Timeflow">
            <app-linechart [salesDataGraph]="barChartData" [categories]="barChartCategories"></app-linechart>
        </app-container-standard>

    </div> -->
    <div *ngIf="isViewCheckActive == 'CATGRAPH' && showSvinnBarChartForCompany" class="col-12">
        <app-container-standard title="Svinn Timeflow">
            <app-linechart [salesDataGraph]="svinnBarChartData" [categories]="svinnBarChartCategories"></app-linechart>
        </app-container-standard>

    </div>



    <div *ngIf="isViewCheckActive == 'GRAPH' && showBarChartForCompany" class="col-12">
        <app-container-standard title="Revenue over time">
            <app-stackedchart [salesDataGraph]="barChartData" [showDataLabels]="true"
                [categories]="barChartCategories"></app-stackedchart>
        </app-container-standard>
    </div>
    <div *ngIf="isViewCheckActive == 'GRAPH' && showBarChartForSystems" class="col-12">
        <app-container-standard title="Revenue by system">
            <app-barchart [showDataLabels]="true" [salesDataGraph]="salesDataGraph"
                [categories]="systemsNameForChart"></app-barchart>
        </app-container-standard>
    </div>
</div>


<!-- <router-outlet></router-outlet> -->

<div class="table-container mat-elevation-z8" style="margin:19px;"
    *ngIf="hideTable == false && isViewCheckActive != 'GRAPH'">
    <ng-container *ngIf="!forceLoading">
        <table mat-table [dataSource]="values$" matSort class="mat-elevation-z8">
            <ng-container *ngFor="let columnSetting of columnSettings" [matColumnDef]="columnSetting.columnId">
                <th class="gray" mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{columnSetting.name}}</th>
                <td mat-cell *matCellDef="let element" class="divider-cell"> {{ element[columnSetting.columnId] }} </td>
                <td mat-footer-cell *matFooterCellDef> {{ columnTotals[columnSetting.columnId] }} </td>

            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumn()"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumn();"></tr>
            <tr mat-header-row *matFooterRowDef="displayedColumn()"></tr>

        </table>
    </ng-container>
    <ng-container *ngIf="forceLoading">
        <app-spinner-loading></app-spinner-loading>
    </ng-container>
</div>

<mat-tab-group *ngIf="isViewCheckActive == 'GRAPH' && showBarChartForCompany">

    <mat-tab label="Systems">
        <app-table-standard-layout
            [dataSource$]="systemsTableDataSub" [title]="'Revenue by system'" [columnSettings]="columnSettingsSystemsTable">
        </app-table-standard-layout>
    </mat-tab>
    <mat-tab label="Total over time">
        <app-table-standard-layout 
            [dataSource$]="timeTableDataSub" [title]="'Revenue over time'" [columnSettings]="columnSettingsTimeTableData">
        </app-table-standard-layout>
    </mat-tab>
</mat-tab-group>